<app-widget [widget-meta]="this.data"
  itemCount="{{ (careerData$ | async)?.allCount}}"
  externalLink="{{( (careerData$ | async)?.baseUrl )}}"
  externalLinkText="All Events"
  showHelp="true">
  <career-grid-display [blocks$]="careerData$" (openModal)="openModal($event, eventsModal)"></career-grid-display>
  <ng-template #eventsModal let-modal>
    <div class="modal-header">
      <h4 tabindex="0" ngbAutofocus class="modal-title" id="modal-basic-title">{{modalTitle}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      </button>
    </div>
    <div class="modal-body">
      <div class="col-lg-12">
        <table class="table table-striped">
          <thead>
            <tr class="table-success">
              <th scope="col">Event Name</th>
              <th scope="col">Location</th>
              <th scope="col">Event Type</th>
              <th scope="col">Start Date</th>

            </tr>
          </thead>
          <tbody>
            @for (event of events; track event) {
              <tr>
                <td scope="row" data-label="EventName">
                  <a href="{{event.Url}}" class="link-dark" target="_blank">{{ event.Name }}</a>&nbsp;
                </td>
                <td scope="row" data-label="Location">
                  {{event.Location}}
                </td>
                <td scope="row" data-label="EventType">
                  {{event.EventTypeName}}
                </td>
                <td data-label="StartDate">
                  {{event.StartDate | date:'EEEE, MMMM d'}}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </ng-template>
</app-widget>
